import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export function openNativeDatePicker(event) {
  const root = event.currentTarget;
  const input =
    root instanceof HTMLInputElement ? root : root.querySelector("input");
  if (!input || typeof input.showPicker !== "function") return;
  try {
    input.showPicker();
  } catch (pickerError) {
    // The same tap already opened the browser calendar.
  }
}

export function nativeDateFieldProps() {
  return {
    inputProps: { inputMode: "none" },
    onClick: openNativeDatePicker,
    onPaste: (event) => event.preventDefault(),
    onKeyDown: (event) => {
      if (event.key !== "Tab") {
        event.preventDefault();
      }
    },
  };
}

const CalendarDatePicker = ({ slotProps, ...props }) => {
  const [open, setOpen] = React.useState(false);
  const textField = slotProps?.textField || {};
  const { inputProps, onClick, onKeyDown, onPaste, ...textFieldRest } =
    textField;

  return (
    <DatePicker
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={{
        ...slotProps,
        textField: {
          ...textFieldRest,
          inputProps: { ...inputProps, readOnly: true },
          onClick: (event) => {
            onClick?.(event);
            setOpen(true);
          },
          onPaste: (event) => {
            event.preventDefault();
            onPaste?.(event);
          },
          onKeyDown: (event) => {
            if (event.key !== "Tab") {
              event.preventDefault();
            }
            onKeyDown?.(event);
          },
        },
      }}
    />
  );
};

export default CalendarDatePicker;
